.shimmer {
  display: inline-block;
  background-image: linear-gradient(
    90deg,
    var(--dixa-typography-color-secondary) 40%,
    var(--dixa-typography-color-primary) 50%,
    var(--dixa-typography-color-secondary) 60%
  );
  background-size: 300% 100%;
  background-position: 100% 0;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shimmerSweep 2s linear infinite;
}

// The gradient is three boxes wide, so the highlight enters and exits fully off the text.
@keyframes shimmerSweep {
  to {
    background-position: 0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .shimmer {
    animation: none;
    background-image: none;
    color: var(--dixa-typography-color-secondary);
    -webkit-text-fill-color: currentcolor;
  }
}
